export function timelapseForm($name) {
    const form = $($name);

    const inputs = form.find($name + '-input');

    if (!form.length || !inputs.length) {
        return;
    }

    let object = {
        'order-type-option-1' : false,
        'order-type-option-2' : false,
    };

    let orderTypeFirstSection = form.find('[data-show-id="order-type-option-1"]');
    let orderTypeSecondSection = form.find('[data-show-id="order-type-option-2"]');

    changeTimeLapseFormState(object, orderTypeFirstSection, orderTypeSecondSection);

    inputs.on('change', function() {
        const id = $(this).attr('id');

        if ($(this).is(':checked')) {
            form.addClass(id);

            object[id] = true;
        } else {
            form.removeClass(id);

            object[id] = false;
        }

        changeTimeLapseFormState(object, orderTypeFirstSection, orderTypeSecondSection);
    });

}

function changeTimeLapseFormState(object, orderTypeFirstSection, orderTypeSecondSection) {
    let orderTypeFirstSectionRequired = orderTypeFirstSection.find('[required="required"]').length ? orderTypeFirstSection.find('[required="required"]') : orderTypeFirstSection.find('[fake-required="required"]');
    let orderTypeSecondSectionRequired = orderTypeSecondSection.find('[required="required"]').length ? orderTypeSecondSection.find('[required="required"]') : orderTypeSecondSection.find('[fake-required="required"]');

    orderTypeFirstSectionRequired.attr('fake-required', 'required');
    orderTypeSecondSectionRequired.attr('fake-required', 'required');

    if (
        !object['order-type-option-2']
    ) {
        //only video

        orderTypeFirstSectionRequired.attr('required', 'required');
        orderTypeSecondSectionRequired.removeAttr('required');

        orderTypeSecondSection.find('input:not([name="date_int"]):not([type="radio"]), textarea, select').val('').prop('checked', false);
        orderTypeSecondSection.find('input[type="radio"]').prop('checked', false);
    } else if (
        !object['order-type-option-1']
    ) {
        //only image

        orderTypeFirstSectionRequired.removeAttr('required');
        orderTypeSecondSectionRequired.attr('required', 'required');

        orderTypeFirstSection.find('input:not([name="date_int"]):not([type="radio"]), textarea, select').val('').prop('checked', false);
        orderTypeFirstSection.find('input[type="radio"]').prop('checked', false);
    } else {
        //both

        orderTypeFirstSectionRequired.attr('required', 'required');
        orderTypeSecondSectionRequired.attr('required', 'required');
    }
}
